import { jitsiLocalStorage } from '@jitsi/js-utils';
import { Box } from '@mui/material';
import { createBrowserHistory } from 'history';
import jwtDecode from 'jwt-decode';
import _ from 'lodash';
import React from 'react';
import { ConfirmPageLeave } from 'react-leave-page-confirm';

import { createToolbarEvent, sendAnalytics } from '../../../analytics';
import { stateType } from '../../../app/stateTypes';
import {
    getConferenceName,
    getConferenceNameForTitle,
    openNotification as openNotifier
} from '../../../base/conference';
import { disableAutoPip, getToolbarButtons } from '../../../base/config';
import { mtDomain } from '../../../base/config/constants';
import { getPictureInPictureModeConfig } from '../../../base/config/functions.any';
import { connect, disconnect } from '../../../base/connection';
import { toggleDialog } from '../../../base/dialog';
import Portal from '../../../base/dialog/components/web/Portal';
import UpperDialog from '../../../base/dialog/components/web/UpperDialog';
import { getWindowWidth, isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n';
import {
    getAllFakeParticipantsLength,
    getLocalParticipant,
    getParticipantCount,
    isLocalParticipantModerator,
    pinParticipant
} from '../../../base/participants';
import { connect as reactReduxConnect } from '../../../base/redux';
import { getDisplayName } from '../../../base/settings';
import { getBrandingColorPalette } from '../../../base/styles';
import { isLocalVideoTrackDesktop } from '../../../base/tracks';
import { Chat } from '../../../chat';
import ImagePreviewModal from '../../../chat/components/web/ImagePreviewModel.js';
import { clickPledgeDialog } from '../../../clickandpledge-givent';
import ClickAndPledgeMarquee from '../../../clickandpledge-givent/components/web/ClickAndPledgeMarquee.js';
import ClickandPledgeParent from '../../../clickandpledge-givent/components/web/ClickandPledgeParent.js';
import ConnectionLostOverlay from '../../../connection-indicator/components/web/ConnectionLostOverlay.js';
import { toggleDonorbox } from '../../../donorbox';
import { Filmstrip } from '../../../filmstrip';
import { setHideHeaderFooter, setTileLimitTileView } from '../../../filmstrip/actions.web';
import { CalleeInfoContainer } from '../../../invite';
import { LargeVideo } from '../../../large-video';
import { setLargeVideoFullscreen } from '../../../large-video/actions.any';
import { KnockingParticipantList, LobbyScreen } from '../../../lobby';
import {
    close as closeParticipantsPane,
    open as openParticipantsPane
} from '../../../participants-pane/actions';
import { ParticipantsPane } from '../../../participants-pane/components';
import { getParticipantsPaneOpen } from '../../../participants-pane/functions';
import { Prejoin, isPrejoinPageVisible } from '../../../prejoin';
import { MaterialNotifier } from '../../../prejoin/components/MaterialNotifier';
import ReactionAnimations from '../../../reactions/components/web/ReactionsAnimations';
import RecordingConsentModalManager from '../../../recording/components/Recording/RecordingConsentModalManager';
import { isVideoPlaying } from '../../../shared-video/functions';
import Captions from '../../../subtitles/components/web/Captions.web.js';
import {
    fullScreenChanged,
    setFullScreen
} from '../../../toolbox/actions.web';
import { Toolbox } from '../../../toolbox/components/web';
import {
    LAYOUTS,
    getCurrentLayout,
    getEffectiveLayout,
    shouldDisplayTileView
} from '../../../video-layout';
import { setPreferredVideoQuality } from '../../../video-quality/actions.js';
import { conferenceViewHandler } from '../../actions.web';
import { filmStripViewStateHandler } from '../../filmStripViewManager';
import {
    getDashBoardUrl,
    maybeShowSuboptimalExperienceNotification
} from '../../functions';
import { getRecorderTargetView, hasActivePriorityContent } from '../../recorderViewHelpers.js';
import {
    AbstractConference,
    abstractMapStateToProps
} from '../AbstractConference';
import type { AbstractProps } from '../AbstractConference';

import { handleConferenceUpdate } from './ConferenceLifecycleHelpers';
import { injectConferenceStyles } from './ConferenceStyles';
import ConfigureYourMeeting from './ConfigureYourMeeting';
import HeaderConference from './HeaderConference';
import MeetingLimitBarrier from './MeetingLimitBarrier';
import MeetingLimitExceededDialog from './MeetingLimitExceededDialog';
import { default as Notice } from './Notice';
import PreLoader from './PreLoader';


declare var APP: Object;
declare var interfaceConfig: Object;
declare var config: Object;

// XXX: We are not currently using state here, but in the future, when
// interfaceConfig is part of redux we will. This will have to be retrieved from the store.

const history = createBrowserHistory();

/**
 * DOM events for when full screen mode has changed. Different browsers need
 * different vendor prefixes.
 *
 * @private
 * @type {Array<string>}
 */
const FULL_SCREEN_EVENTS = [
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'fullscreenchange'
];

// const styleConference = {
//     display: 'none',
//     opacity: '100%'
// };

const styleAd = {
    display: 'inline-block',
    height: '200px',
    width: '100%'
};
const styleMHAd: React.CSSProperties = {
    display: 'inline-block',
    height: 'auto',
    width: '50%'
};

const DEFAULT_ADS_DIALOG_REFRESH_INTERVAL = 5 * 60 * 1000;

// Delay before the first ad is shown after the user joins the conference.
const DEFAULT_ADS_DIALOG_INITIAL_DELAY = 5 * 1000;

/**
 * The CSS class to apply to the root element of the conference so CSS can
 * modify the app layout.
 *
 * @private
 * @type {Object}
 */
const LAYOUT_CLASSNAMES = {
    [LAYOUTS.HORIZONTAL__filmStripView]: 'horizontal-filmstrip',
    [LAYOUTS.TILE_VIEW]: 'vertical-filmstrip',
    [LAYOUTS.VERTICAL__filmStripView]: 'vertical-filmstrip'
};

/**
 * The type of the React {@code Component} props of {@link Conference}.
 */
type Props = AbstractProps & {

    /**
     * Whether the local participant is recording the conference.
     */
    _iAmRecorder: boolean,

    /**
     * Returns true if the 'lobby screen' is visible.
     */
    _isLobbyScreenVisible: boolean,

    /**
     * If participants pane is visible or not.
     */
    _isParticipantsPaneVisible: boolean,

    /**
     * The CSS class to apply to the root of {@link Conference} to modify the
     * application layout.
     */
    _layoutClassName: string,

    /**
     * Name for this conference room.
     */
    _roomName: string,

    /**
     * If prejoin page is visible or not.
     */
    _showPrejoin: boolean,

    /**
     * Join error text shared from prejoin state.
     */
    _joinErrorMessage: string,

    dispatch: Function,

    /**
     *  Password.
     */
    _password: String,

    _room: Object,

    _isOpen: boolean,

    /**
     * Is the person moderator.
     */
    _isModerator: boolean,

    /**
     * If the conference has started just that moment.
     */
    _isAlone: boolean,

    /**
     * Timer.
     */
    _timer: number,

    t: Function,

    _mhConferenceJoined: boolean,

    pollsTabFocused: boolean,

    /**
     * _isLobbyScreenVisible in lobby reducer.
     */
    _isLobbyScreenVisibl: boolean,

    /**
     * OPen Notification.
     */
    openNotification: ?Boolean,

    /**
     * Notification Details.
     */
    notifierDetails: ?Object,

    /**
     * The connection status of the local participant.
     */
    _localParticipantConnectionStatus: string,

    handleClose: Function,

    /**
     * Returns boolean if the user is screensharing.
     */
    _isSharing: boolean,

    /**
     * PictureInPictureEnabled State
     */
    _isPictureInPictureEnabled: boolean,

    /**
     * User Disabled Auto PiP State
     */
    userDisabledAutoPiP: boolean,
};

/**
 * The conference page of the Web application.
 */
class Conference extends AbstractConference<Props, *> {
    _onFullScreenChange: Function;
    _onShowToolbar: Function;
    _originalOnShowToolbar: Function;
    roomCreateInvitation: Function;

    /**
   * Initializes a new Conference instance.
   *
   * @param {Object} props - The read-only properties with which the new
   * instance is to be initialized.
   */
    constructor(props) {
        super(props);
        this.state = {
            headerview: 'fixed',
            headerviewtext: 'Fixed View',
            headerviewstyle: 'row',
            isOpen: false,
            PollEnabled: false,
            Ctitle: 'Poll ',
            ispolls: false,
            disablepipdialog: false,
            colorsAssigned: false,
            hasShownExpiringNotification: false,
            timeOut: null,
            iframeshared: false,
            isConferenceEmbedded: false,
            forceCustomAds: false,
            screenSize: this.getScreenSize(getWindowWidth()),
            windowWidth: getWindowWidth(),
            recorderinfloat: false,
            showMessage: false,
            sharingState: {
                screenshare: false,
                filmstrip: undefined,
                objectFit: undefined,
                lastVideoShare: false
            },
            isResizing: false

            // _filmStripView: 'Vertical' // Vertical, Horizontal, Title
        };

        // Throttle and bind this component's mousemove handler to prevent it
        // from firing too often.
        this._originalOnShowToolbar = this._onShowToolbar;
        this._onShowToolbar = _.throttle(() => this._originalOnShowToolbar(), 100, {
            leading: true,
            trailing: false
        });

        this.roomCreateInvitation = _.once(() => {
            const data = jitsiLocalStorage.getItem('features/onCreateconference');
            const parser = JSON.parse(data || '{}');

            if (parser.FirstOpenDialog) {
                const parse = parser.FirstOpenDialog.roomName;

                if (!parse.includes(this.props._roomName)) {
                    parser.FirstOpenDialog.roomName.push(this.props._roomName);
                    jitsiLocalStorage.setItem(
                        'features/onCreateconference',
                        JSON.stringify(parser)
                    );
                    this.props.dispatch(toggleDialog(ConfigureYourMeeting));
                }
            }

            if (!('FirstOpenDialog' in parser)) {
                const addObject = {
                    roomName: [ `${this.props._roomName}` ]
                };

                parser.FirstOpenDialog = addObject;
                jitsiLocalStorage.setItem(
                    'features/onCreateconference',
                    JSON.stringify(parser)
                );
                this.props.dispatch(toggleDialog(ConfigureYourMeeting));
            }
        });

        // Bind event handler so it is only bound once for every instance.
        this._onFullScreenChange = this._onFullScreenChange.bind(this);
        this._onDialogHandle = this._onDialogHandle.bind(this);
        this._onHandleTimeOut = this._onHandleTimeOut.bind(this);
        this.adCycleTimeout = null;
        this.googleAdElement = null;
        this.lastDialogToggleTime = 0;

        // Ensures the first ad after joining is shown only once.
        this._initialAdShown = false;
        this.getScreenSize = this.getScreenSize.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this._onShowToolbar = this._onShowToolbar.bind(this);
        this._onExpiringNotificationShown = this._onExpiringNotificationShown.bind(this);
        this.hideTimeout = null;
        this.pipFilmstrip = undefined;
        this.pip_participants_pane = false;
    }

    getScreenSize = width => {
        if (width < 500) {
            return 'mobile';
        } else if (width < 800) {
            return 'tablet';
        }

        return 'laptop';

    };

    /**
     * Check if the conference is embeded.
     */
    checkIfConferenceIsEmbeded() {
        try {
            // Check if running in an iframe
            const isEmbedded = window.self !== window.top;

            this.setState({
                isConferenceEmbedded: isEmbedded
            });
        } catch (e) {
            // Cross-origin restrictions - we're in an iframe
            this.setState({
                isConferenceEmbedded: true
            });
        }
    }

    /**
     * Check if the notfication is embeded.
     */
    _onExpiringNotificationShown(value) {
        this.setState({ hasShownExpiringNotification: value });
    }


    /**
   * Start the connection and get the UI ready for the conference.
   *
   * @inheritdoc
   */
    componentDidMount() {
        this.checkIfConferenceIsEmbeded();
        document.title = `${this.props._roomName} | ${interfaceConfig.APP_NAME}`;
        this._start();
        if (this.props._room && document.body) {
            document.body.style.overflow = 'hidden';
        }

        this._maybeStartInitialAd();
        this.props.dispatch(toggleDonorbox());

        if (this.props._isScreenSharing) {
            this.props.dispatch(pinParticipant(this.props._screenSharingParticipantId, true));
        }

        const checked = jitsiLocalStorage.getItem('features/video-quality-checked');

        if (checked === 'true') {
            const persistedPrefferedVideoQuality
                = jitsiLocalStorage.getItem('features/video-quality-persistent-storage');
            let videoQuality;

            try {
                videoQuality = persistedPrefferedVideoQuality
                    ? JSON.parse(persistedPrefferedVideoQuality)
                    : undefined;
            } catch (e) {
                videoQuality = undefined;
            }

            if (typeof videoQuality?.persistedPrefferedVideoQuality !== 'undefined') {
                this.props.dispatch(setPreferredVideoQuality(videoQuality.persistedPrefferedVideoQuality));
            }
        }

        // Recorder view setup — use centralized helper for consistent behavior
        if (config.iAmRecorder) {
            const state = APP.store.getState();
            const targetView = getRecorderTargetView(state);

            if (this.props.filmStripView !== targetView) {
                this.props.dispatch(filmStripViewStateHandler(targetView));
            }

            // Set tile limit based on target view
            if (targetView === LAYOUTS.TILE_VIEW) {
                this.props.dispatch(setTileLimitTileView(29));
            } else if (targetView === LAYOUTS.STAGE_VIEW) {
                this.props.dispatch(setTileLimitTileView(0));
            } else {
                this.props.dispatch(setTileLimitTileView(6));
            }

            // If priority content was already active before the recorder joined,
            // re-select the large video participant to show the correct one
            if (hasActivePriorityContent(state)) {
                this.props.dispatch(selectParticipantInLargeVideo());
            }
        } else {
            const state = APP.store.getState();
            const effectiveLayout = getEffectiveLayout(state, this.props.filmStripView);

            if (this.props.filmStripView !== effectiveLayout) {
                this.props.dispatch(filmStripViewStateHandler(effectiveLayout));
            }
        }

        const pipLocalState = jitsiLocalStorage.getItem('features/base/settings/disableAutoPIP');

        this.props.dispatch(
            disableAutoPip(pipLocalState === true || pipLocalState === 'true')
        );

        window.addEventListener('resize', this.handleResize);

        injectConferenceStyles(interfaceConfig, isMobileBrowser());

    }

    /**
   * Component that will mount in the conference.
   *
   * @inheritdoc
   */
    UNSAFE_componentWillMount() {
        // const { dispatch } = this.props;

        // dispatch(fetchpreRegApi());
        const { desktopapp } = this.props;

        // Loading the Google Ads script when needed.
        if (!this.state.isConferenceEmbedded && desktopapp !== 1) {
            if (document.body && window.location.hostname === 'meethour.io') {
                const existingScript = document.getElementById('GoogleAdsScript');

                if (existingScript) {
                    return;
                }

                const script = document.createElement('script');

                script.src
                    = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5885538074079594';
                script.id = 'GoogleAdsScript';
                script.async = true;
                script.crossorigin = 'anonymous';
                document.body && document.body.appendChild(script);
            }
        }
    }

    /**
   * Calls into legacy UI to update the application layout, if necessary.
   *
   * @inheritdoc
   * returns {void}
   */
    componentDidUpdate(prevProps) {
        handleConferenceUpdate(this, prevProps);
    }

    /**
   * Disconnect from the conference when component will be
   * unmounted.
   *
   * @inheritdoc
   */
    componentWillUnmount() {
        window.removeEventListener('online', this._onOnline);
        window.removeEventListener('offline', this._onOffline);
        APP.UI.unbindEvents();
        clearTimeout(this.timeout); // Cleanup to avoid memory leaks
        clearTimeout(this.loaderErrorRefreshTimer);
        this._clearAdCycleTimer();

        FULL_SCREEN_EVENTS.forEach(name =>
            document.removeEventListener(name, this._onFullScreenChange)
        );

        APP.conference.isJoined() && this.props.dispatch(disconnect());
        window.removeEventListener('resize', this.handleResize);

        // Reset screensharing state for next conference
        this.setState({
            sharingState: {
                screenshare: false,
                filmstrip: undefined,
                objectFit: undefined
            }
        });
    }

    handleResize = _.debounce(() => {
        const width = getWindowWidth();
        const screenSize = this.getScreenSize(width);
        const { largevideofullscreen, hideHeaderFooter, dispatch } = this.props;

        if (width > 500) {
            if (largevideofullscreen) {
                dispatch(setLargeVideoFullscreen(false));
            }
            if (hideHeaderFooter) {
                dispatch(setHideHeaderFooter(false));
            }
        }

        if (window.innerHeight > width) { // Portrait mode
            if (hideHeaderFooter) {
                dispatch(setHideHeaderFooter(false));
            }
        }

        this.setState({
            screenSize,
            windowWidth: width
        });
    }, 250);

    /**
     * Toggles the full screen mode.
     */
    _onToolbarToggleFullScreen() {
        sendAnalytics(
            createToolbarEvent('toggle.fullscreen', {
                enable: !this.props._fullScreen
            })
        );

        this._doToggleFullScreen();
    }

    /**
     * Toggles the full screen mode.
     */
    _doToggleFullScreen() {
        const fullScreen = !this.props._fullScreen;

        this.props.dispatch(setFullScreen(fullScreen));
    }

    /**
     * Toggles the participants pane
     */
    toggleParticipantsPane() {
        this.props._isParticipantsPaneVisible
            ? this.props.dispatch(closeParticipantsPane())
            : this.props.dispatch(openParticipantsPane());
    }

    _onHandleConferenceView = () => {
        this.props._conferenceView === 'fixed'
            ? this.setState({
                headerview: 'float',
                headerviewtext: this.props.t('settingsView.FloatingView'),
                headerviewstyle: 'row-reverse'
            })
            : this.setState({
                headerview: 'fixed',
                headerviewtext: this.props.t('settingsView.FixedView'),
                headerviewstyle: 'row'
            });
        this.props._conferenceView === 'fixed'
            ? this.props.dispatch(conferenceViewHandler('float'))
            : this.props.dispatch(conferenceViewHandler('fixed'));
        jitsiLocalStorage.setItem('conferenceView', this.props._conferenceView === 'fixed' ? 'float' : 'fixed');


        if (this.props._conferenceView === 'float') {
            const element = document.getElementById('react');

            if (element) {
                element.style.setProperty('overflow', 'hidden auto', 'important');
            }
        } else {
            const element = document.getElementById('react');

            if (element) {
                element.style.setProperty('overflow', 'hidden', 'important');
            }
        }

    };

    /**
     * Renders a powered by block if it is enabled.
     *
     * @private
     * @returns {ReactElement|null}
     */
    _renderPoweredBy() {
        if (this.props.showPoweredBy) {
            const { t } = this.props;

            return (
                <a
                    className = 'poweredby'
                    href = 'https://meethour.io?web-embed=true'
                    target = '_new'>
                    <span>{t('poweredby')}</span>
                </a>
            );
        }

        return null;
    }

    /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {ReactElement}
   */
    render() {
        const {
            _iAmRecorder,
            _isParticipantsPaneVisible,
            _showPrejoin,
            _mhConferenceJoined,
            displayHeaderInRecorder,
            _isLobbyScreenVisibl,
            notifierDetails,
            openNotification,
            _conferenceEnded,
            _isOpen,
            pregData,
            _isClickandPledgeEnabled,
            _isLoading,
            _joinErrorMessage,
            _isPictureInPictureEnabled,
            filmStripView,
            _isParticiapntsPaneOpen,
            _conferenceView,
            streamoptions,
            t,
            _isSwitchingBreakOutRoom,
            hideHeaderFooter,
            _isSwitchingToMainRoom,
            largevideofullscreen
        } = this.props;
        const isMobile = getWindowWidth() < 500;
        const isVerticalFilmstrip = filmStripView === LAYOUTS.VERTICAL_FILMSTRIP_VIEW;
        const isHorizontalFilmstrip = filmStripView === LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW;
        const isTileFilmstrip = filmStripView === LAYOUTS.TILE_VIEW;

        // Showing ads to show for free users randomly
        const adsBannersArray = [
            'images/adremovalbanner.jpg',
            'images/adlivestream.jpg',
            'images/adpayasyougo.jpg',
            'images/adpreregistration.jpg',
            'images/adsdks.jpg',
            'images/ad-annotations.jpg',
            'images/ad-livestranscription.jpg',
            'images/ad-livestreaming.jpg',
            'images/ad-recording.jpg',
            'images/ad-whiteboard.jpg'
        ];

        const l = adsBannersArray.length - 1;
        const n = Math.round(Math.random() * l);

        const finalAdImage = adsBannersArray[n];

        // Use _shouldAttemptGoogleAds() to ensure consistent logic with domain check
        const shouldShowGoogleAd = !this.state.forceCustomAds && this._shouldAttemptGoogleAds();

        const participants_pane_width = window.innerWidth <= 500
            ? '100%'
            : window.innerWidth <= 800
                ? window.innerWidth <= 730 ? '100%' : '312px'
                : '414px';


        const videoSpaceContainerStyle = {
            flexDirection: isHorizontalFilmstrip ? 'column' : isVerticalFilmstrip ? 'row-reverse' : null,
            display: (window.innerWidth <= 730) && (_isOpen || _isParticiapntsPaneOpen) ? 'none' : '',
            padding: _isPictureInPictureEnabled || window.innerWidth <= 500 ? '0px 0px' : largevideofullscreen ? '0px' : '0px 10px 0px 0px'
        };

        const videoConferencePageStyle = {
            background: getBrandingColorPalette(interfaceConfig)?.background,
            display: _showPrejoin ? 'none' : null
        };

        // const singleRecorderLeft = _iAmRecorder && this.props._participantCount <= 0;

        const filmStripContainerStyle = {
            display: this.props._participantCount === 1 && _iAmRecorder ? 'none' : 'flex'
        };

        const VideoSpaceStyle = {
            padding: !displayHeaderInRecorder && config.iAmRecorder ? '10px 0 10px 10px' : window.innerWidth <= 500 || _isPictureInPictureEnabled
                ? '10px 10px 10px 10px' : largevideofullscreen ? '5px' : '10px 0 10px 10px'
        };

        return (
            <div
                id = 'layout_wrapper'>
                {this._renderPoweredBy()}
                {streamoptions.SVS === 1 && !_isPictureInPictureEnabled && <ClickAndPledgeMarquee />}
                {((_showPrejoin && _mhConferenceJoined) || _isLobbyScreenVisibl) && <Prejoin />}
                {_isSwitchingBreakOutRoom && <div className = 'status-message'>{t('breakoutRooms.joiningMessage')}</div>}
                {_isSwitchingToMainRoom && <div className = 'status-message'>{t('breakoutRooms.leavingMessage')}</div>}
                {_conferenceEnded ? <PreLoader
                    interfaceConfig = { interfaceConfig }
                    message = { this.props.t('dialog.closingAllTerminals') } />
                    : (<div
                        className = { `${largevideofullscreen ? 'largevideofullscreen' : hideHeaderFooter ? 'hideHeaderFooter' : ''} 
                                conference-${_conferenceView} ${_isPictureInPictureEnabled ? 'picture-in-picture' : ''}` }
                        id = 'videoconference_page'
                        style = { videoConferencePageStyle }>
                        {_isOpen && <Chat />}
                        {!_iAmRecorder && <ClickandPledgeParent />}
                        {_isParticiapntsPaneOpen && !_isPictureInPictureEnabled && <ParticipantsPane />}

                        {_isLoading || !config.prejoinPageEnabled ? _mhConferenceJoined
                                && <div className = 'status-message'>
                                    {_isLoading
                                        ? this.props.t('welcomepage.joinmeeting')
                                        : !config.prejoinPageEnabled && _joinErrorMessage
                                            ? _joinErrorMessage
                                            : this.props.t('welcomepage.joinmeeting')}
                                </div>
                            : _mhConferenceJoined && <PreLoader interfaceConfig = { interfaceConfig } />}
                        {(!_showPrejoin || !_isLobbyScreenVisibl)
                            && (config.iAmRecorder ? displayHeaderInRecorder !== false && <HeaderConference
                                hasShownExpiringNotification = { this.state.hasShownExpiringNotification }
                                onExpiringNotificationShown = { this._onExpiringNotificationShown }
                                onOpenDialog = { this._onOpenDialog }
                                onToolbarToggleFullScreen = { () => this._onToolbarToggleFullScreen() }
                                renderE2EELabel = { () => this._renderE2EELabel() }
                                renderInsecureRoomNameLabel = { () => this._renderInsecureRoomNameLabel() }
                                renderLocalRecordingLabel = { () => this._renderLocalRecordingLabel() }
                                renderRecordingLabel = { mode => this._renderRecordingLabel(mode) }
                                renderTranscribingLabel = { () => this._renderTranscribingLabel() }
                                toggleParticipantsPane = { () => this.toggleParticipantsPane() } /> : <HeaderConference
                                hasShownExpiringNotification = { this.state.hasShownExpiringNotification }
                                onExpiringNotificationShown = { this._onExpiringNotificationShown }
                                onOpenDialog = { this._onOpenDialog }
                                onToolbarToggleFullScreen = { () => this._onToolbarToggleFullScreen() }
                                renderE2EELabel = { () => this._renderE2EELabel() }
                                renderInsecureRoomNameLabel = { () => this._renderInsecureRoomNameLabel() }
                                renderLocalRecordingLabel = { () => this._renderLocalRecordingLabel() }
                                renderRecordingLabel = { mode => this._renderRecordingLabel(mode) }
                                renderTranscribingLabel = { () => this._renderTranscribingLabel() }
                                toggleParticipantsPane = { () => this.toggleParticipantsPane() } />)}
                        <Notice />
                        <div
                            id = 'videospace'
                            style = { VideoSpaceStyle }>
                            {<div
                                className = { `videospace-container  ${isTileFilmstrip ? 'tile-view' : ''}` }
                                id = { `${filmStripView}-container` }
                                style = { videoSpaceContainerStyle }>
                                {filmStripView !== LAYOUTS.TILE_VIEW && <ConnectionLostOverlay
                                    _participant = { this.props._localParticipant }
                                    filmStripView = { filmStripView } />}

                                { <div
                                    className = 'filmstrip-container'
                                    style = { filmStripContainerStyle }>

                                    <Filmstrip
                                        _filmStripView = { filmStripView }
                                        _isMobile = { isMobile }
                                        chatWidth = { participants_pane_width }
                                        isPaneOpen = { _isOpen || _isParticiapntsPaneOpen || _isClickandPledgeEnabled } />
                                </div>
                                }
                                <LargeVideo
                                    _conferenceView = { _conferenceView }
                                    _filmStripView = { filmStripView }
                                    _screenSize = { this.state.screenSize }
                                    dispatch = { this.props.dispatch }
                                    hview = { _conferenceView } />
                            </div>}
                            {!_isParticipantsPaneVisible && <KnockingParticipantList />}

                            {_isOpen && !this.props._meetingLimitExceeded && <Chat />}
                            {!_iAmRecorder && <ClickandPledgeParent />}
                            {_isParticiapntsPaneOpen && !_isPictureInPictureEnabled && !this.props._meetingLimitExceeded && <ParticipantsPane />}

                        </div>
                        {!interfaceConfig.DISABLE_TRANSCRIPTION_SUBTITLES && <Captions conferenceView = { _conferenceView } />}

                        {<MaterialNotifier

                            handleClose = { () =>
                                this.props.dispatch(openNotifier(!openNotification))
                            }
                            notification = { notifierDetails }
                            openNotifier = { openNotification } />}
                        <CalleeInfoContainer />
                        {!(_iAmRecorder || _showPrejoin || _isLobbyScreenVisibl) && !_mhConferenceJoined && !this.props._meetingLimitExceeded && (
                            <Toolbox
                                _isOpen = { _isOpen }
                                hview = { _conferenceView === 'fixed' ? 'fixed' : null }
                                isPictureInPicture = { _isPictureInPictureEnabled }
                                roomName = { this.props._roomName } />)}
                    </div>)}
                {this.renderNotificationsContainer()}
                <ReactionAnimations />
                <ImagePreviewModal />
                <RecordingConsentModalManager />
                {typeof pregData === 'object'
                        && pregData !== null
                        && pregData.hasOwnProperty('display_ads')
                        && !config.iAmRecorder
                        && pregData?.display_ads === true
                        && (
                            <Portal>
                                <UpperDialog
                                    dialogColor = 'rgba(0, 0, 0, 0.83)'
                                    isOpen = { this.state.isOpen }
                                    onDialogHandle = { this._onDialogHandle }
                                    urlFunction = { getDashBoardUrl }>
                                    <Box
                                        display = 'flex'
                                        justifyContent = 'center'>
                                        {shouldShowGoogleAd ? (
                                            <ins
                                                className = 'adsbygoogle'
                                                data-ad-client = 'ca-pub-5885538074079594'
                                                data-ad-slot = '2439626115'
                                                ref = { element => {
                                                    this.googleAdElement = element;
                                                } }
                                                style = { styleAd } />
                                        ) : (
                                            <img
                                                alt = { 'banner ad' }
                                                src = { finalAdImage }
                                                style = { styleMHAd } />
                                        )}
                                    </Box>
                                </UpperDialog>
                            </Portal>
                        )}
                {(window.location.hostname === 'meethour.io' || window.location.hostname === 'meethour.org') && window.self === window.top && (
                    <ConfirmPageLeave
                        history = { history }
                        isActive = { this.props._room } />
                )}
                {this.props._meetingLimitExceeded && (
                    <MeetingLimitBarrier>
                        <MeetingLimitExceededDialog />
                    </MeetingLimitBarrier>
                )}
            </div>

        );
    }

    /**
   * Updates the Dialog state and prepares appropriate ad content.
   *
   * @private
   * @returns {void}
   */
    _onDialogHandle() {
        // Prevent rapid toggling with 500ms cooldown
        const now = Date.now();
        const timeSinceLastToggle = now - this.lastDialogToggleTime;

        if (timeSinceLastToggle < 500) {
            return; // Ignore rapid successive calls
        }

        this.lastDialogToggleTime = now;
        const isOpening = !this.state.isOpen;

        if (isOpening) {
            // Opening dialog - determine ad type immediately
            this._clearAdCycleTimer();

            if (this._shouldAttemptGoogleAds()) {
                // Try Google ads - open with Google ad slot
                this.setState({
                    isOpen: true,
                    forceCustomAds: false
                }, () => {
                    requestAnimationFrame(() => {
                        this._tryPushGoogleAd();

                        // Check after 2.5s if Google ad rendered
                        window.setTimeout(() => {
                            if (this._didGoogleAdRender()) {
                                return;
                            }

                            // No Google ad, switch to custom
                            this.setState({ forceCustomAds: true });
                        }, 2500);
                    });
                });
            } else {
                // Show custom ads immediately (localhost, IP, desktop, embedded, etc.)
                this.setState({
                    isOpen: true,
                    forceCustomAds: true
                });
            }
        } else {
            // Closing dialog
            this.setState({ isOpen: false }, () => {
                this._scheduleNextAdOpen();
            });
        }
    }

    /**
   * Returns whether ads are enabled for the current meeting context.
   *
   * @param {Object} [props=this.props] - Component props.
   * @returns {boolean}
   */
    _isAdsEnabled(props = this.props) {
        const { pregData } = props;

        return typeof pregData === 'object'
            && pregData !== null
            && pregData.hasOwnProperty('display_ads')
            && pregData?.display_ads === true
            && !config.iAmRecorder;
    }

    /**
   * Returns whether the ads dialog is eligible to be shown.
   *
   * @param {Object} [props=this.props] - Component props.
   * @returns {boolean}
   */
    _shouldShowAdsDialog(props = this.props) {
        return this._isAdsEnabled(props);
    }

    /**
   * Checks if the parent domain matches the allowed MeetHour domain.
   * Returns false for localhost, IP addresses, and non-meethour.io domains.
   *
   * @returns {boolean}
   */
    _isParentDomainAllowed() {
        try {
            const parentHostname = window.parent.location.hostname;

            // Reject localhost, IPs, and non-meethour.io domains
            if (!parentHostname || parentHostname === 'localhost'
                || /^\d+\.\d+\.\d+\.\d+$/.test(parentHostname)) {
                return false;
            }

            return parentHostname === mtDomain || parentHostname.endsWith(`.${mtDomain}`);
        } catch (e) {
            // Cross-origin iframe - check current window
            const currentHostname = window.location.hostname;

            // Reject localhost, IPs, and non-meethour.io domains
            if (!currentHostname || currentHostname === 'localhost'
                || /^\d+\.\d+\.\d+\.\d+$/.test(currentHostname)) {
                return false;
            }

            return currentHostname === mtDomain || currentHostname.endsWith(`.${mtDomain}`);
        }
    }

    /**
   * Returns whether the Google ad slot should be used.
   *
   * @returns {boolean}
   */
    _shouldAttemptGoogleAds() {
        const { desktopapp } = this.props;

        return desktopapp !== 1
            && !this.state.isConferenceEmbedded
            && this._isParentDomainAllowed();
    }

    /**
   * Clears the active ad refresh timer.
   *
   * @returns {void}
   */
    _clearAdCycleTimer() {
        if (this.adCycleTimeout) {
            clearTimeout(this.adCycleTimeout);
            this.adCycleTimeout = null;
        }
    }

    /**
   * Returns the ad refresh interval in milliseconds.
   * Prefers pre-registration config and falls back to 10 minutes.
   *
   * @returns {number}
   */
    _getAdsRefreshInterval() {
        const refreshInterval = Number(this.props?.pregData?.refresh_ads);

        return Number.isFinite(refreshInterval) && refreshInterval > 0
            ? refreshInterval
            : DEFAULT_ADS_DIALOG_REFRESH_INTERVAL;
    }

    /**
   * Detects whether the Google ad has rendered content.
   * Only returns true if an actual ad iframe is present.
   *
   * @returns {boolean}
   */
    _didGoogleAdRender() {
        const adElement = this.googleAdElement;

        if (!adElement) {
            return false;
        }

        const adStatus = adElement.getAttribute('data-ad-status');

        if (adStatus === 'filled') {
            return true;
        }

        if (adStatus === 'unfilled') {
            return false;
        }

        // Only consider it rendered if there's an actual iframe with ad content
        const iframe = adElement.querySelector('iframe');

        return Boolean(iframe);
    }

    /**
     * Safely triggers Google AdSense to fill an uninitialized ad element in the DOM.
     * Prevents calling adsbygoogle.push({}) if no unprocessed <ins class="adsbygoogle">
     * element exists in the DOM, which would otherwise trigger "Error: no_div" in adsbygoogle.js.
     *
     * @returns {boolean} True if an ad push was attempted, false otherwise.
     */
    _pushGoogleAd() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return false;
        }

        // Only push if an uninitialized <ins class="adsbygoogle"> element exists in the DOM
        const uninitializedAd = document.querySelector('ins.adsbygoogle:not([data-adsbygoogle-status])');

        if (!uninitializedAd) {
            return false;
        }

        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});

            return true;
        } catch (error) {
            return false;
        }
    }

    /**
     * Safely attempts to push to Google AdSense once the uninitialized <ins> element
     * is mounted in the DOM. Retries briefly to allow React portal rendering to complete.
     *
     * @param {number} [retries=3] - Number of retry attempts remaining.
     * @returns {void}
     */
    _tryPushGoogleAd(retries = 3) {
        if (this._pushGoogleAd()) {
            return;
        }

        if (retries > 0) {
            window.setTimeout(() => {
                this._tryPushGoogleAd(retries - 1);
            }, 100);
        }
    }

    /**
   * Refreshes ad content and opens the ads dialog.
   *
   * @returns {void}
   */
    _prepareAdAndOpenDialog() {
        if (!this._shouldShowAdsDialog()) {
            return;
        }

        if (!this._shouldAttemptGoogleAds()) {
            this.setState({
                forceCustomAds: true,
                isOpen: true
            });

            return;
        }

        // Open dialog first with Google ad slot so the <ins> element renders in DOM
        this.setState({
            forceCustomAds: false,
            isOpen: true
        }, () => {
            // Wait for render, then try to fill the Google ad
            requestAnimationFrame(() => {
                this._tryPushGoogleAd();

                // Wait longer (2.5s) to give Google more time to load the ad
                window.setTimeout(() => {
                    const didGoogleRender = this._didGoogleAdRender();

                    // If Google ad didn't render, switch to custom ads
                    if (!didGoogleRender) {
                        this.setState({ forceCustomAds: true });
                    }
                }, 2500);
            });
        });
    }

    /**
   * Opens the first ad shortly after the user joins the conference.
   * Runs at most once; later ads are scheduled when the dialog is closed.
   *
   * @returns {void}
   */
    _maybeStartInitialAd() {
        // Only show the first ad while ads are enabled and the user has actually
        // joined the conference (not while still on the prejoin/lobby screen).
        if (this._initialAdShown
                || !this._shouldShowAdsDialog()
                || !this.props._conferenceJoined
                || this.props._showPrejoin) {
            return;
        }

        this._initialAdShown = true;
        this._clearAdCycleTimer();
        this.adCycleTimeout = window.setTimeout(() => {
            this._prepareAdAndOpenDialog();
        }, DEFAULT_ADS_DIALOG_INITIAL_DELAY);
    }

    /**
   * Schedules the next ads dialog open event.
   *
   * @returns {void}
   */
    _scheduleNextAdOpen() {
        if (!this._shouldShowAdsDialog()) {
            return;
        }

        this._clearAdCycleTimer();
        this.adCycleTimeout = window.setTimeout(() => {
            this._prepareAdAndOpenDialog();
        }, this._getAdsRefreshInterval());
    }

    /**
   * Starts/stops ad scheduling based on eligibility transitions.
   *
   * @param {Object} prevProps - Previous props.
   * @returns {void}
   */
    _syncAdScheduler(prevProps) {
        const wasEligible = this._shouldShowAdsDialog(prevProps);
        const isEligible = this._shouldShowAdsDialog(this.props);

        if (isEligible) {
            // Show the first ad shortly after the user joins. This is a no-op
            // once the initial ad has already been shown; subsequent ads are
            // scheduled when the dialog is closed.
            this._maybeStartInitialAd();
        }

        if (!isEligible && wasEligible) {
            this._clearAdCycleTimer();

            if (this.state.isOpen || this.state.forceCustomAds) {
                this.setState({
                    forceCustomAds: false,
                    isOpen: false
                });
            }
        }
    }

    /**
   * Updates the Dialog
   * disabled.
   *
   * @param {any} timeOuts - Time Out.
   * @returns {void}
   */
    _onHandleTimeOut(timeOuts) {
        this.setState(prevState => {
            return {
                ...prevState,
                timeOut: timeOuts
            };
        });
    }


    /**
     * Callback invoked to display Donorbox Modal {@code DonorBox}.
     *
     * @param {number} e - The first number.
     *
     * @private
     * @returns {void}
     */
    _onDonate = e => {
        e.preventDefault();

        // window.open(this.props._geturl);

        // this.props.dispatch(getMeethourDonorboxEnabled());

        // this.props.dispatch(toggleDialog(donorboxDialog));

    };

    _onOpenDialog = e => {
        e.preventDefault();

        this.props.dispatch(toggleDialog(clickPledgeDialog));

        // this.props.dispatch(toggleDialog())
    };

    /**
   * Updates the Redux state when full screen mode has been enabled or
   * disabled.
   *
   * @private
   * @returns {void}
   */
    _onFullScreenChange() {
        this.props.dispatch(fullScreenChanged(APP.UI.isFullScreen()));
    }

    /**
   * Until we don't rewrite UI using react components
   * we use UI.start from old app. Also method translates
   * component right after it has been mounted.
   *
   * @inheritdoc
   */
    _start() {
        APP.UI.start();

        APP.UI.registerListeners();
        APP.UI.bindEvents();

        FULL_SCREEN_EVENTS.forEach(name =>
            document.addEventListener(name, this._onFullScreenChange)
        );

        const { dispatch, t } = this.props;

        dispatch(connect());

        maybeShowSuboptimalExperienceNotification(dispatch, t);

        // this.props.dispatch(registerSound(USER_WAITING_REGISTER, USER_WAITING_SOUND, {loop: true }));
    }

    _renderE2EELabel: () => React$Element<*>;

    _renderLocalRecordingLabel: () => React$Element<*>;

    _renderRecordingLabel: string => React$Element<*>;

    _renderTranscribingLabel: () => React$Element <*>;

    _renderInsecureRoomNameLabel: () => React$Element < any >;

    _renderVideoQualityLabel: () => React$Element <*>;

}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code Conference} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
    const {
        password,
        conference,
        timer,
        isCustomParticipantVisible,
        objectFit,
        mhConferenceJoined,
        conferenceSubject,
        conferenceExpired,
        pollsTabFocused,
        openNotification,
        notifierDetails,
        colorPicker,
        meetingLimitExceeded,
        meetingLimitDetails
    } = state['features/base/conference'];
    const { pregData } = state['features/base/mtApi'];
    const {
        lobbyScreen: { _isLobbyScreenVisible },
        lobbyEnabled,
        disabledLobbySound
    } = state['features/lobby'];
    const { jwt, jwtData, meetingDetails } = state['features/base/jwt'];
    const { userDetails, desktopapp } = state['features/base/mtApi'];
    const isPersonModerator = isLocalParticipantModerator(state);
    const participantCount = getParticipantCount(state);
    const { accessToken } = state['features/base/jwt'];
    const whiteBoardVisible = state['features/genericiframe'].visible;
    const etherPadVisible = state['features/etherpad'].editing;
    const { isEnabled, formGUID, giventToken } = state['features/clickandpledge'];
    const interfaceConfigToolbarButtons = getToolbarButtons(state);
    const isSharing = isLocalVideoTrackDesktop(state);
    const name = getDisplayName(state);
    const { conferenceEnded, isConnecting } = state['features/base/conference'];
    const { joinErrorMessage } = state['features/prejoin'];
    const isAlone = participantCount === 1;
    const showPoweredBy = interfaceConfig.SHOW_POWERED_BY;
    const jwtSubject = jwt ?? jwtData;
    const desktopApp = state[stateType.base.mtApi].desktopapp;
    const isDeskTop = interfaceConfig.ENABLE_DESKTOP_DEEPLINK === false && desktopApp === 1;
    const rawDialog = state['features/base/dialog'].rawDialog;
    const PIPDisabled = state['features/base/config'].disableAutoPiP;
    const participants = state['features/base/participants'];
    const streamoptions = state['features/clickandpledge']?.streamOptions;
    const isSwitchingBreakOutRoom = state['features/base/mtApi']?.isSwitchingBreakOutRoom;
    const isSwitchingToMainRoom = state['features/base/mtApi']?.isSwitchingToMainRoom;
    const { tileViewTileLimit, hideHeaderFooter } = state['features/filmstrip'];
    const { largevideofullscreen } = state['features/large-video'];
    const undefinedColors = participants.filter(p => p.color === undefined);
    const isSharedVideoVisible = isVideoPlaying(state);

    const {
        displayHeaderInRecorder,
        displayLogoInRecorder
    } = interfaceConfig;
    let jwtDecoded;

    if (jwtSubject) {
        const jwtt = jwtDecode(jwtSubject);

        jwtDecoded = jwtt ? jwtt.meeting ? jwtt.meeting.topic : null : null;
    }

    // To check picture-in-picture
    const isPictureInPictureEnabled = getPictureInPictureModeConfig(state);

    let timeInMins;

    if (timer) {
        const time = timer.split(':')[0];


        timeInMins = parseInt(time, 10);
    }

    return {
        ...abstractMapStateToProps(state),
        _iAmRecorder: state['features/base/config'].iAmRecorder,
        _isLobbyScreenVisible:
            state['features/base/dialog']?.component === LobbyScreen,
        _isParticipantsPaneVisible: getParticipantsPaneOpen(state),
        _layoutClassName: LAYOUT_CLASSNAMES[getCurrentLayout(state)],
        _roomName: getConferenceNameForTitle(state),
        _showPrejoin: isPrejoinPageVisible(state),
        _password: password,
        tileViewTileLimit,
        hideHeaderFooter,
        largevideofullscreen,
        _isModerator: isPersonModerator,
        _room: conference,
        userDisabledAutoPiP: PIPDisabled,
        streamoptions,
        _isAlone: isAlone,
        _timer: timeInMins,
        pregData,
        fakeParticipantsLength: getAllFakeParticipantsLength(state),
        rawDialog,
        conferenceExpired,
        isDeskTop,
        lobbyEnabled,
        _jwt: jwt,
        _isSharing: isSharing,
        _mhConferenceJoined: !mhConferenceJoined,
        _isLobbyScreenVisibl: _isLobbyScreenVisible,
        pollsTabFocused,
        openNotification,
        notifierDetails,
        _objectFit: objectFit,
        name,
        _conferenceSubject: conferenceSubject,
        accessToken,
        displayLogoInRecorder,
        userDetails,
        designation: userDetails?.designation,
        company: userDetails?.company,
        showPoweredBy,
        desktopapp,
        _colorPicker: colorPicker, // Multiple, Static, Custom
        _tileViewState: shouldDisplayTileView(state),
        _participantCount: participantCount,
        _isClickandPledgeEnabled: isEnabled,
        _clickandpledgeform: giventToken ?? formGUID,
        whiteBoardVisible,
        etherPadVisible,
        isCustomParticipantVisible,
        _conferenceJoined: mhConferenceJoined,
        disabledLobbySound,
        _conferenceEnded: conferenceEnded,
        _subject: meetingDetails?.topic ?? jwtDecoded ?? getConferenceName(state),
        _isLoading: isConnecting,
        _joinErrorMessage: joinErrorMessage,
        displayHeaderInRecorder,
        joinanytime: meetingDetails?.settings?.JOIN_ANYTIME === 1,
        _participants: participants,
        _participantsColorUndifined: undefinedColors.length,
        interfaceConfigToolbarButtons,
        _isPictureInPictureEnabled: isPictureInPictureEnabled,
        _isSharedVideoVisible: isSharedVideoVisible,
        _isSwitchingBreakOutRoom: isSwitchingBreakOutRoom,
        _isSwitchingToMainRoom: isSwitchingToMainRoom,
        _localParticipantConnectionStatus: getLocalParticipant(state)?.connectionStatus,
        _localParticipant: getLocalParticipant(state),
        _meetingLimitExceeded: meetingLimitExceeded,
        _meetingLimitDetails: meetingLimitDetails

    };
}

export default reactReduxConnect(_mapStateToProps)(translate(Conference));
